import './ListSearch.scss'

import React, { useEffect, useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Link, useSearchParams } from 'react-router-dom'

import { Icon } from 'hb4e-ui-core-ui'
import { Loading, updateTitle } from 'hb4e-ui-core'

import EmptyResults from './EmptyResults/EmptyResults'
import SearchResults from './SearchResults/SearchResults'
import { searchLists } from '../../../actions'
import { urlListView } from '../../../urls'
import { selectListSearchResults } from '../../../reducers'

const ListSearch = () => {
  const dispatch = useDispatch()
  const [searchParams] = useSearchParams()
  const searchTerm = searchParams.get('term')

  const searchResults = useSelector(selectListSearchResults)
  const searchResultsCount = useMemo(() => {
    const numLists = searchResults?.listResults?.totalElements ?? 0
    const numItems = searchResults?.itemResults?.length ?? 0

    return numLists + numItems
  }, [searchResults])

  // Fetch search results
  useEffect(() => {
    if (!searchResults.isStale) {
      return
    }

    dispatch(searchLists(searchTerm))
  }, [searchTerm, dispatch])

  // Updates the page title
  useEffect(() => {
    dispatch(updateTitle('Search My Lists'))
  }, [])

  if (!searchResults) {
    return <Loading />
  }

  return (
    <div className="list-search">
      <div className="list-search__container">
        <div className="list-search__search-header">
          <Link to={urlListView()} className="list-search__back-link">
            <Icon.ArrowLeft className="list-search__back-link-icon" />
            Back to My Lists
          </Link>

          <div className="list-search__search-term-container">
            <span className="list-search__search-term-label">You searched for</span>
            <br />
            <span className="list-search__search-term">“{searchTerm}”</span>
          </div>
        </div>

        {searchResultsCount > 0 ? <SearchResults searchResults={searchResults} /> : <EmptyResults />}
      </div>
    </div>
  )
}

export default ListSearch
